import b from 'b_';
import {
    H3,
    SimpleCallback,
    Text,
    TEXT_MARKUP_TYPE,
    UI_KIT_HEADER_TYPOGRAPHY,
    UI_KIT_TEXT_TYPOGRAPHY,
} from 'platform-components';
import React, { forwardRef } from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import { ContentShowcaseGradient } from 'common.components/widgets.content-showcase/__gradient/content-showcase__gradient';

import { ContentShowcaseIcon } from '../__icon/content-showcase__icon';
import { BLOCK_SIZE, ContentShowcaseWidgetItemData } from '../typings';

import './content-showcase__item.scss';

interface Props {
    data: ContentShowcaseWidgetItemData;
    onClick: SimpleCallback;
    style?: React.CSSProperties;
    size: BLOCK_SIZE | null;
}

export const ContentShowcaseItem = React.memo(
    forwardRef((props: Props, ref: React.Ref<HTMLDivElement>) => {
        const { data, onClick, style, size } = props;
        const { name, description, items, visualSettings } = data;

        return (
            <div
                className={b('content-showcase-widget', 'item', { size, animated: true })}
                ref={ref}
                style={style}
                {...accessibleClick(onClick)}
            >
                <div className="content-showcase-widget__item-bg">
                    <ContentShowcaseGradient colors={visualSettings?.colors} />
                </div>
                <div className="content-showcase-widget__item-desc">
                    <div className="content-showcase-widget__item-title">
                        <H3 type={TEXT_MARKUP_TYPE.MARKDOWN} typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMBold}>
                            {name}
                        </H3>
                    </div>
                    <div className="content-showcase-widget__item-description">
                        <Text typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}>{description}</Text>
                    </div>
                </div>
                <div
                    className={b('content-showcase-widget', 'inner-items')}
                    style={{ gridTemplateColumns: `repeat(${Math.ceil(items?.length / 2)}, 1fr)` }}
                >
                    {items?.map((item, index) => {
                        return <ContentShowcaseIcon key={index} src={item.icon} />;
                    })}
                </div>
            </div>
        );
    })
);
